"use client"
import dynamic from 'next/dynamic';
import React from 'react'
import Link from 'next/link'
import { Phone, PhoneCall } from 'lucide-react'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'
import useScrollTrigger from '@/hooks/use-scroll-trigger'
import { useSession } from '../auth/session-provider'
import MaxWidthContainer from './max-width-container'
import { api } from '@/trpc/react'
import { LOGO } from '@/lib/constant'
import Image from 'next/image'
import SearchTrigger from './search-trigger';
// import OfferMarquee from './OfferMarquee';
const DynamicDesktopNavigation = dynamic(() =>
    import('./desktop-navigation').then(mod => mod.DesktopNavigation), {
    ssr: true,
    loading: () => <div className="hidden lg:block h-10 w-96 animate-pulse bg-gray-700/50 rounded" />
});

const DynamicMobileNavigation = dynamic(() =>
    import('./mobile-navbar').then(mod => mod.MobileNavigation), {
    ssr: false, // Mobile menu can be client-side only to reduce bundle size
    loading: () => <div className="lg:hidden h-9 w-10 animate-pulse bg-white rounded-md" />
});

const   Navbar = () => {
    // Optimize data fetching with caching
    const { data, isLoading } = api.global.get_navbar.useQuery(undefined, {
        staleTime: 5 * 60 * 1000, // 5 minutes cache
    });

    const { session } = useSession();
    const navActive = useScrollTrigger(123);
    const path = usePathname();

    return (
        <>
            {/* <OfferMarquee navActive={navActive} path={path} /> */}
            <nav className={cn("sticky top-0 z-30 h-full w-full",
                path === "/about-us" || path === "/featured-trips" ? "bg-[#141416]/5 backdrop-blur-sm" : "",
                path === "/" || path === "/enquiry-form" ? "bg-transparent backdrop-blur-none" : '',
                navActive || path.includes("/trip/") || path?.includes("/trek/") ? "bg-custom-primary-dark backdrop-blur-none transition duration-300" : ""
            )}>    
                <MaxWidthContainer className='flex items-center justify-between gap-5 md:px-2.5 xl:px-10'>
                    {/* Left side */}
                    <div className='flex gap-6 items-center justify-between w-full'>
                        <div className="relative h-16 lg:h-20 w-40 ">
                            <Link href={"/"} className='h-full w-full'>
                                <Image
                                    src={LOGO}
                                    alt="Trek Karo"
                                    fill
                                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                    loading="eager"
                                    priority={true}
                                    quality={50}
                                    className='object-contain object-left'
                                />
                            </Link>
                        </div>
                        <div className='flex items-center md:justify-between gap-5 w-fit md:w-full'>
                            <Link
                                href={"tel:+919699958061"}
                                className='md:flex justify-center items-center gap-2 h-9 w-fit px-2.5 bg-[#353945]/15 backdrop-blur-sm border border-white/10 rounded-md group cursor-pointer text-sm text-white text-nowrap overflow-hidden text-ellipsis hidden'
                            >
                                <Phone className='size-4 fill-white' strokeWidth={0} />
                                (+91) 9699958061
                            </Link>
                            <Link href={"tel:+919699958061"} className='md:hidden relative size-9 rounded-full p-2 group'>
                                <span className='absolute top-0 left-0 h-full w-full bg-custom-primary lg:scale-0 lg:group-hover:scale-100 transition duration-500 rounded-full' />
                                <PhoneCall className='h-full w-full fill-white -rotate-2' strokeWidth={0} />
                            </Link>
                            <SearchTrigger />
                        </div>
                    </div>

                    {/* Right side */}
                    <div className='flex gap-5 items-center w-fit'>
                        {/* Desktop navigation */}
                        <DynamicDesktopNavigation
                            data={data ?? { destination_cat: [], trip_cat: [], trek_cat: [] }}
                            isLoading={isLoading}
                            path={path}
                        />

                        <span className='h-7 w-0.5 scale-x-50 shrink-0 bg-white hidden md:block' />

                        <DynamicMobileNavigation
                            data={data ?? { destination_cat: [], trip_cat: [], trek_cat: [] }}
                            session={session}
                        />
                    </div>
                </MaxWidthContainer>
            </nav>
        </>
    );
};

export default Navbar